__webpack_require__.p = "/wp-content/landings/cosmos_magnit/";